var render, staticRenderFns
import script from "./CallStaticsChartComponent.vue?vue&type=script&lang=ts&"
export * from "./CallStaticsChartComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23193d00",
  null
  
)

export default component.exports